import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

export const ReportUserResource = {
  postReportUser: (receiverId: string, reason: string) =>
    AffinyEndpoint.ReportUser.url(`/${receiverId}/report`)
      .post({
        data: {
          attributes: { reason },
        },
      })
      .res(),
};
